export function checkMechanic(state: { mechanic: { phoneNumber: string; name: string } | null }) {
    const mechanic = state.mechanic;
    if (!!mechanic && (!mechanic.phoneNumber || mechanic.phoneNumber.length < 3) && !mechanic.name) {
        state.mechanic = null;
    }
}
